import React, {useState} from "react";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import logo from "../../images/logo/logo_full.png";
import loadingGif from "../../images/loading.gif";
import axios from 'axios';
import { baseURL } from "../../baseURL";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [disabledButton, setDisabledButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailSendStatus, setEmailSendStatus] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setEmailSendStatus(false);
    setDisabledButton(true);


    if (!isValidEmail(email)) {
      setError("Email is not valid.")
      setDisabledButton(false);
      setLoading(false);
      return "";
    }

    const data = {
      email: email
    }

    try {
      const response = await axios.post(baseURL+'/api/user/password/reset-password-request', data);
      if(response.data.status === 'ok') {
        setEmailSendStatus(true);
      } else {
        setError(response.data.text);
      }
    } catch(err) {

    }
    
    setDisabledButton(false);
    setLoading(false);

    // history.push("/");
  };

  function isValidEmail(email) {
    // Regular expression for email validation
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        {" "}
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to="/">
                        <img src={logo} width="120" alt="" />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 ">Forgot Password</h4>

                    
                    {emailSendStatus === true && (
                      <Alert variant="success" className="alert-dismissible fade show">
                        <b>Password reset requested.</b> We've just checked our records. If they show that we have an account matching , we'll send a password reset email.
                      </Alert>
                    )}

                    {error !== "" && (
                      <Alert variant="danger" className="alert-dismissible fade show">
                        {error}
                      </Alert>
                    )}

                    <form onSubmit={(e) => onSubmit(e)}>
                      <div className="form-group">
                        <label className="">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="hello@example.com"
                          onChange={(e) => {setEmail(e.target.value); setError('')} }
                        />
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary btn-block justify-content-center align-items-center h-100" disabled={disabledButton}>
                          {loading === false && (
                            <span>SUBMIT</span>
                          )}
                          {loading === true && (
                            <span><img alt="" src={loadingGif} width="18" /></span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
